import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ErrorIcon = styled(FontAwesomeIcon)`
    font-size: 16px;
    color: ${props => (props.error ? "rgb(216, 40, 41)" : "rgb(253, 185, 39)")};
`;
